// src/components/Speicherorte.js
import React, { useState, useEffect } from "react";
import { selectDirectory, hasSelectedDirectory } from "../utils/fileSystem";
import "./Speicherorte.css";

const Speicherorte = () => {
  const [speicherorte, setSpeicherorte] = useState({
    "Enge Räume": localStorage.getItem("engeraumSpeicherort") || "",
    "Feuerlöscher": localStorage.getItem("feuerloescherSpeicherort") || "",
    "Dienstübergabe": localStorage.getItem("dienstuebergabeSpeicherort") || "",
    "Berichte": localStorage.getItem("berichteSpeicherort") || "",
  });
  
  const [dirHandleStatus, setDirHandleStatus] = useState({
    "Enge Räume": false,
    "Feuerlöscher": false,
    "Dienstübergabe": false,
    "Berichte": false,
  });

  // Lädt gespeicherte Werte beim ersten Laden
  useEffect(() => {
    // Prüft, ob das currentDirHandle existiert
    const hasHandle = hasSelectedDirectory();
    if (hasHandle) {
      const newStatus = {};
      Object.keys(speicherorte).forEach(bereich => {
        newStatus[bereich] = true;
      });
      setDirHandleStatus(newStatus);
    }
  }, [speicherorte]);

  // Funktion zum Ändern eines Speicherorts im State
  const handleSpeicherortChange = (bereich, event) => {
    const neuerSpeicherort = event.target.value;
    setSpeicherorte({
      ...speicherorte,
      [bereich]: neuerSpeicherort,
    });
  };

  // Funktion zum Speichern im Local Storage
  const handleSaveLocation = (bereich) => {
    const neuerSpeicherort = speicherorte[bereich];
    if (neuerSpeicherort) {
      // Konsistente Benennung für die Speicherortschlüssel
      let storageKey;
      
      // Spezielle Behandlung für Enge Räume, um konsistent zu sein
      if (bereich === "Enge Räume") {
        storageKey = "engeraumSpeicherort"; // Korrigiert - konsistente Schreibweise
      } else {
        // Für andere Bereiche wie bisher, aber ohne Leerzeichen
        storageKey = `${bereich.toLowerCase().replace(/\s+/g, "")}Speicherort`;
      }
      
      localStorage.setItem(storageKey, neuerSpeicherort);
      alert(`Speicherort für ${bereich} gespeichert: ${neuerSpeicherort}`);
    } else {
      alert("Bitte einen Speicherort auswählen.");
    }
  };

  // Verbesserte Version mit File System API
  const handleDirectorySelect = async (bereich) => {
    try {
      const dirName = await selectDirectory();
      
      if (dirName) {
        // Aktualisiere den Speicherort in der State
        setSpeicherorte({
          ...speicherorte,
          [bereich]: dirName
        });
        
        // Aktualisiere den Handle-Status
        setDirHandleStatus({
          ...dirHandleStatus,
          [bereich]: true
        });
        
        // Speichere im localStorage - angepasste Schlüsselnamen für alle Bereiche
        let storageKey;
        if (bereich === "Enge Räume") {
          storageKey = "engeraumSpeicherort"; // Korrigiert - konsistente Schreibweise
        } else {
          storageKey = `${bereich.toLowerCase().replace(/\s+/g, "")}Speicherort`;
        }
        
        localStorage.setItem(storageKey, dirName);
        
        // WICHTIG: Stelle sicher, dass der Directory Handle global verfügbar ist
        // window.currentDirHandle wird bereits von selectDirectory gesetzt
        
        alert(`Verzeichnis für ${bereich} erfolgreich ausgewählt: ${dirName}`);
      }
    } catch (error) {
      console.error("Fehler bei der Verzeichnisauswahl:", error);
      alert(`Fehler bei der Verzeichnisauswahl: ${error.message}`);
    }
  };

  return (
    <div className="speicherorte-container">
      <h2>Speicherorte Einstellungen</h2>
      <p>Hier können Sie die Speicherorte für verschiedene Bereiche der Anwendung festlegen.</p>
      
      <div className="speicherorte-list">
        {Object.keys(speicherorte).map((bereich) => (
          <div key={bereich} className="speicherort-item">
            <label>{bereich}:</label>
            <div className="speicherort-controls">
              <input
                type="text"
                value={speicherorte[bereich]}
                onChange={(e) => handleSpeicherortChange(bereich, e)}
                placeholder={`Speicherort für ${bereich}`}
                readOnly={true} // Macht das Feld schreibgeschützt, damit Benutzer den Pfad nicht manuell ändern können
              />
              <button 
                onClick={() => handleSaveLocation(bereich)}
                className="save-button"
                disabled={!dirHandleStatus[bereich]}
              >
                Speichern
              </button>
              <button 
                onClick={() => handleDirectorySelect(bereich)}
                className="browse-button"
              >
                Durchsuchen...
              </button>
            </div>
            <div className="speicherort-status">
              {dirHandleStatus[bereich] ? (
                <span className="status-active">✓ Bereit zum Speichern</span>
              ) : (
                <span className="status-inactive">⚠ Bitte Ordner auswählen</span>
              )}
            </div>
          </div>
        ))}
      </div>
      
      <div className="info-box">
        <h3>Hinweis zur Speicherung</h3>
        <p>
          Verwenden Sie die Schaltfläche "Durchsuchen...", um einen Ordner auszuwählen,
          in dem Ihre Daten gespeichert werden sollen. Aus Sicherheitsgründen müssen Sie
          nach jedem Neustart der App den Ordner erneut auswählen.
        </p>
        <p>
          <strong>Wichtig:</strong> In privaten Browsing-Modi oder wenn Cookies gelöscht werden,
          können die Berechtigungen verloren gehen. Wählen Sie in diesem Fall die Ordner erneut aus.
        </p>
      </div>
    </div>
  );
};

export default Speicherorte;